import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { ListItemButton } from '@mui/material';
import List from '@mui/material/List';
import useSurveyRefDataHook from './useSurveyRefDataHook';
import { onTableRowClick } from "../table-panels/TablePanelsVM";
declare const window: any;






const SurveyRefWidget = ({view,activeWidget, layerIds}) => {
  
  const [visible, setVisible] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const containerDiv = useRef<any>()
  const {columns,rows, featureDict}=useSurveyRefDataHook(layerIds,view);
  const refColumns = [
    {
      field:"MapType",
      headerName:"Conveyance/MapType",
       minWidth:200,
    },
    {
      field:"No",
      headerName:"No.",
       minWidth:200,
    },
    {
      field:"DocumentReference",
      headerName:"Document Reference",
      minWidth:200,
    },
      {
          field:"DateField",
          headerName:"Recorded/Survey Date",
          minWidth:200,
      },
      {
        field:"LSRE",
        headerName:"LS/RE",
        minWidth:200,
    },
    {
      field:"COC",
      headerName:"Certificate Of Correction",
    //  type: 'actions',
      minWidth:300,
      renderCell: (cellValues) => { 
        let coctags = '';
        let coctaglist = []
        if ((cellValues.row.COC !== null) && (cellValues.row.COC !='')){
          if (cellValues.row.COC.split(" ").length > 0){
            cellValues.row.COC.split(" ").forEach(function(ornum){
              if(ornum.length>2){
                let url = "https://www.ocgis.com/OCPW/Services/OCSurvey/Document/ShowDoc?DocNum="+encodeURIComponent(ornum)+"&type=CC"
              let tag = ' <a href=' + url + ' target="_blank">#' + ornum + '</a><br>';
              coctaglist.push(tag)
           //   coctags += tag
              
              }
            })
          }
        }
        return (
          <List style={{ display: 'flex' }}>
            {cellValues.row.COC.split(' ').map((id) => (
              <ListItemButton  key={id}  component="a" target="_blank" href = {"https://www.ocgis.com/OCPW/Services/OCSurvey/Document/ShowDoc?DocNum="+encodeURIComponent(id.trim())+"&type=CC"}>
                {id}
              </ListItemButton>
            ))}
          </List>
        )}
      }
  ]




  const handleMyClick = (id) => {
    //console.log(selectionModel)
  };

  // Function to handle row selection changes
  const handleSelectionModelChange = (selectionModel) => {
    setSelectedRows(selectionModel);
  };
    // Function to log the selected rows data on button click
    function replaceNullWithSpace(item) {
      if ((item !== null) && (item !== undefined) && (item.trim() !== '')) {
       return item
      } else {
        return ''
      }
    }

    const handleButtonClick = () => {
     const selectedData = rows.filter((row) => selectedRows.includes(row.id));
     var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel"  xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
     tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';
     tab_text = tab_text + '<x:Name>Ref Doc Sheet</x:Name>';
     tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
     tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
     tab_text = tab_text + "<table border='1px'><tr><th >Reference</th> <th >Conveyance <br> / Map Type</th><th>No.</th><th >Document <br>Reference</th> <th >Recorded <br>/ Survey Date</th><th >LS/RE#</th><th >Certificate<br> of <br>Correction</th></tr><tr>"
     selectedData.forEach(function (doc) {
      let doctype ='';
      let atag = '';
      let docref = doc.DocumentReference;
      let numurl = "https://www.ocgis.com/OCPW/Services/OCSurvey/Document/ShowDoc?DocNum="
      
      if (doc.MapType =='Corner Record' ){
        doctype = 'CR'
        numurl +=  encodeURIComponent(docref)+"&type="+doctype;
      }
      
      if (doc.MapType =='Parcel Map' ){
        doctype = 'PM'
        numurl +=encodeURIComponent(docref)+ "&type="+doctype;
      }
     
      if (doc.MapType == 'Record of Survey' ){
        doctype = 'RS'
        numurl += encodeURIComponent(docref)+ "&type="+doctype;
      }
      
      if (doc.MapType == 'Tract Map'){
        doctype = 'TR'
        numurl += encodeURIComponent(docref)+ "&type="+doctype;
      }
      
      if (doc.MapType == 'Alignment Note'){
        doctype = 'AN'
        let andoc = docref.replace("&", "_")
        numurl += encodeURIComponent(docref)+ "&type="+doctype;
      }
      
      if (doc.MapType == 'Topographic Survey'){
        doctype = 'TS'
        numurl += encodeURIComponent(docref)+ "&type="+doctype;
      }
      
      if (doc.MapType == 'County Surveyor Tie Book'){
        doctype = 'CSTB'
        numurl += encodeURIComponent(docref)+ "&type="+doctype;
      }
      
      if (doc.MapType == 'Jack Raub Note'){
        doctype = 'JRN'
        numurl += encodeURIComponent(docref)+ "&type="+doctype;
      }
      
      if (doc.MapType =='City Tie'){
        doctype = 'CT'
        numurl += encodeURIComponent(docref)+ "&type="+doctype;
      }

      if (doc.MapType == 'Lot Line Adjustment'){
        doctype = 'LLA'
        numurl += encodeURIComponent(docref)+ "&type="+doctype;
        docref = '#'+doc.DocumentReference
      }
      let coctags = '';
      let coctaglist = []
      if ((doc.COC !== null) && (doc.COC !='')){
        if (doc.COC.split(" ").length > 0){
          doc.COC.split(" ").forEach(function(ornum){
            if(ornum.length>2){
              let url = "https://www.ocgis.com/OCPW/Services/OCSurvey/Document/ShowDoc?DocNum="+encodeURIComponent(ornum)+"&type=CC"
            let tag = ' <a href=' + url + ' target="_blank">#' + ornum + '</a><br>';
            coctaglist.push(tag)
         //   coctags += tag
            
            }
          })
        }
      }
      
      coctags = coctaglist.join();
      atag = '<a href=' + numurl + ' target="_blank">' + docref + '</a>';

      tab_text = tab_text +"<td>R</td><td>"+doc.MapType+"</td><td>"+replaceNullWithSpace(doc.No)+"</td><td>"+atag+"</td><td>"+replaceNullWithSpace(doc.DateField)+"</td><td>"+replaceNullWithSpace(doc.LSRE)+"</td><td>"+coctags+"</td></tr>"
     })
     tab_text = tab_text + '</table></body></html>';
     var fileName = 'References_'+ Date.now()+'.xls';
     //Save the file
     var blob = new Blob([tab_text], {
       type: "application/vnd.ms-excel;charset=utf-8"
     })
     window.saveAs(blob, fileName);
    };
    
    const handlerowClick = (e) => {
        onTableRowClick(view,featureDict[e.row.layername+e.id])
       };

       const handleOnCellClick = (params) => {
      };




       // window.saveAs
// Shims the saveAs method, using saveBlob in IE10.
// And for when Chrome and FireFox get round to implementing saveAs we have their vendor prefixes ready.
// But otherwise this creates a object URL resource and opens it on an anchor tag which contains the "download" attribute (Chrome)
// ... or opens it in a new tab (FireFox)
// @author Andrew Dodson
// @copyright MIT, BSD. Free to clone, modify and distribute for commercial and personal use.

window.saveAs || ( window.saveAs = (window.navigator.msSaveBlob ? function(b,n){ return window.navigator.msSaveBlob(b,n); } : false) || window.webkitSaveAs || window.mozSaveAs || window.msSaveAs || (function(){

	// URL's
	window.URL || (window.URL = window.webkitURL);

	if(!window.URL){
		return false;
	}

	return function(blob,name){
		var url = URL.createObjectURL(blob);
    //window.open(url, '_blank', '');
		// Test for download link support
		if( "download" in document.createElement('a') ){

			var a = document.createElement('a');
			a.setAttribute('href', url);
			a.setAttribute('download', name);

			a.style.display = 'none';
		  document.body.appendChild(a);

		  a.click();

		  document.body.removeChild(a);

		}
		else{
			// fallover, open resource in new tab.
			window.open(url, '_blank', '');
		}
	};

})() );


  useEffect(() => {
    if (activeWidget === 'Survey Reference') {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [activeWidget]);

  return (
    <>
    {visible&&<div ref={containerDiv} style={{ display:"block",height: 400, width: '100%' }}>
        <Button onClick={handleButtonClick}>Export selected rows</Button>
<DataGrid
        rows={rows}
        columns={refColumns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        checkboxSelection={true}
        onRowClick={(e)=>handlerowClick(e)}
        onRowSelectionModelChange={handleSelectionModelChange}
        rowSelectionModel={selectedRows}
        onCellClick={(e)=>handleOnCellClick(e)}
      />
    </div>}
    </>
  )
}

export default SurveyRefWidget